/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ShConfiguration } from '../../models/sh-configuration';

export interface GetConfiguration$Params {
}

export function getConfiguration(http: HttpClient, rootUrl: string, params?: GetConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<ShConfiguration>> {
  const rb = new RequestBuilder(rootUrl, getConfiguration.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ShConfiguration>;
    })
  );
}

getConfiguration.PATH = '/rest/configuration';
